import { Component, Input, OnInit } from "@angular/core";
import { SharedService } from "../../services";

@Component({
    selector: "app-primary-color-header",
    templateUrl: "./primary-color-header.component.html",
    styleUrls: ["./primary-color-header.component.scss"],
})
export class PrimaryColorHeaderComponent implements OnInit
{

    @Input() useSecondaryText?: boolean = false; // do we want to use secondary text color or just white if theme is// dark?

    public isDark: boolean;
    public customCSS: string = "";

    constructor(
        private sharedService: SharedService,
    ) { }

    ngOnInit(): void
    {
        this.isDark = this.sharedService.isDark;
        this.getCustomCss();
    }

    // sets the text color based on if theme is dark or light, and
    // if dark, if we want to use secondary color vs the white.
    getCustomCss()
    {
        if (!this.isDark)
        {
            this.customCSS = "primary-color";
        } 
        else if (this.useSecondaryText)
        {
            this.customCSS = "secondary-text-color";
        }
    }
}
